import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRequestService, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { GetPartnersResponse } from '../shared/getpartnersresponse';
import { Partner } from '../shared/partner';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],
    standalone: true,
    imports: [ListViewComponent, ListViewComponent, TranslationPipe]
})
export class PartnersComponent implements OnInit {
    getPartnersURI = '/admin/getPartners';

    partnerDetailsURI = '/partnerdetails';

    partners: Partner[] = [];

    storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);

    private _router = inject(Router);

    private _apiRequestService = inject(ApiRequestService);

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            void this._router.navigateByUrl('/');
        }
        this._loadPartners();
    }

    onSelectPartner(partnerId: number | undefined, partnerName: string | undefined): void {
        void this._router.navigate([this.partnerDetailsURI], {
            queryParams: { partnerId: partnerId, partnerName: partnerName }
        });
    }

    private _loadPartners(): void {
        this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.getPartnersURI).subscribe((response) => {
            const getPartners = response as GetPartnersResponse;
            this.partners = getPartners.partnerList as Partner[];
        });
    }
}
